// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1___df4e31268dd6d8d6a23","cls2":"CitationModal-cls2__a4a86ad1201e98ec1f40 CitationModal-cls1___df4e31268dd6d8d6a23"};